"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var scan_1 = require("rxjs/internal/operators/scan");
var get_1 = require("lodash-es/get");
var set_1 = require("lodash-es/set");
var cloneDeep_1 = require("lodash-es/cloneDeep");
function createServiceGetter(ns, store) {
    return function () {
        var inst = get_1.default(window, ns);
        if (!inst) {
            set_1.default(window, ns, store);
        }
        return get_1.default(window, ns);
    };
}
exports.createServiceGetter = createServiceGetter;
function createStore(defaultState, features) {
    var _a = features || {}, _b = _a.reducer, reducer = _b === void 0 ? function (s) { return s; } : _b, _c = _a.middlewares, middlewares = _c === void 0 ? [] : _c;
    var mutations = new rxjs_1.Subject();
    var stream = new rxjs_1.BehaviorSubject(defaultState);
    mutations
        .pipe(scan_1.scan(function (state, mutation) {
        var nextState = mutation(cloneDeep_1.default(state));
        middlewares.forEach(function (mdw) { return mdw(state, nextState); });
        return mutation(state);
    }, defaultState))
        .subscribe(stream);
    return {
        destroy: function () {
            mutations.complete();
            stream.complete();
        },
        obs: stream.asObservable(),
        getValue: function () {
            return stream.getValue();
        },
        next: function (m) {
            mutations.next(m);
        },
        dispatch: function (action) {
            mutations.next(function (state) { return reducer(state, action); });
        },
    };
}
exports.createStore = createStore;
//# sourceMappingURL=index.js.map